import { combineReducers } from "redux";
import app from "./app";
import auth from "./auth";
import todo from "./todo";
import product from "./product";
import workOrderForm from "./forms/workOrderForm";
import enamelPaintingForm from "./forms/enamelPaintingForm";
import { appActions} from "./app";
import { authActions } from './auth';
import { todoActions } from "./todo";
import { productActions } from "./product";
import { workOrderFormActions } from "./forms/workOrderForm";
import { enamelPaintingFormActions } from "./forms/enamelPaintingForm";

const rootReducer = combineReducers({app, auth, todo, product, workOrderForm, enamelPaintingForm});

export {
    rootReducer,
    appActions,
    authActions,
    todoActions,
    productActions,
    workOrderFormActions, 
    enamelPaintingFormActions
}